module.exports = __webpack_public_path__ + "media/images/lb/286-a7d2b1d59ab97b3e331ba21f1d7a4998.svg";